// Config for differentpages' versions based on geo location

export const GEO_LOCATION_CONFIG = {
	DEFAULT: {
		homepage: {
			// Template 1
			pagePath: '/',
			pageName: 'Homepage', // For mapping with SEO meta tags
			headingList: [
				'Revolutionize your Facilities Management with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs',
				'Award-Winning Facilities Management Software / CMMS',
			],
			heroTagline: 'The Leading Cloud-Based Facilities Management Software',
			heroMessage:
				'Streamline operations, automate maintenance and improve efficiency with our powerful, easy-to-use facilities management software',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule In-Person Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	IN: {
		homepage: {
			// Template 1
			pagePath: '/in',
			pageName: 'Homepage India',
			headingList: [
				'Revolutionize your Facilities Management with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs',
				'Award-Winning Facilities Management Software / CMMS',
			],
			heroTagline: 'Leading Cloud-Based Facilities Management Software in India',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in India.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule In-Person Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	MY: {
		homepage: {
			// Template 1
			pagePath: '/my',
			pageName: 'Homepage Malaysia',
			headingList: [
				'Revolutionize Facilities Management in Malaysia with FacilityBot CMMS',
				'Use a single, powerful platform for all your facilities management needs in Malaysia.',
				'Award-Winning Facilities Management Software / CMMS in Malaysia',
			],
			heroTagline: 'The Leading Cloud-Based Facilities Management Software in Malaysia',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our award-winning Facilities Management Software (CMMS) for Malaysia.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule In-Person Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	PH: {
		homepage: {
			// Template 1
			pagePath: '/ph',
			pageName: 'Homepage Philippines',
			headingList: [
				'Revolutionize Facilities Management in the Philippines with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs in the Philippines',
				'Award-Winning Facilities Management Software / CMMS in the Philippines',
			],
			heroTagline: 'Leading Cloud-Based Facilities Management Software in the Philippines',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in the Philippines.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule In-Person Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	AE: {
		homepage: {
			// Template 1
			pagePath: '/ae',
			pageName: 'Homepage UAE',
			headingList: [
				'Revolutionize Facilities Management in Dubai with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs in Dubai',
				'Award-Winning Facilities Management Software / CMMS in Dubai',
			],
			heroTagline: 'Leading Cloud-Based Facilities Management Software in Dubai',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in Dubai.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule In-Person Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
};
